import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import {
  taggedDataErrorsSelector,
} from './store/selectors';
import {
  clearUploadTaggedDataErrors,
} from './store/actions';

const ErrorRow = ({ message, row }) => (
  <div className="scenario-import-error-row">
    <span>Row {row}</span>
    <span>{message}</span>
  </div>
);
ErrorRow.propTypes = {
  message: PropTypes.string,
  row: PropTypes.number,
};

const ImportErrors = ({ errors, clearUploadTaggedDataErrors }) => {
  if (errors && errors.length) {
    return (
      <div
        className={classnames([
          'scenario-import-alert-container',
          'alert',
          'alert-dismissible',
          'show',
          'alert-danger',
        ])} role="alert"
      >
        <b>Import errors:</b>
        {errors.slice(0, 15).map(({ row, message }) => (<ErrorRow key={row} message={message} row={row} />))}
        <button
          type="button"
          className="close"
          onClick={clearUploadTaggedDataErrors}
        >
          <span>&times;</span>
        </button>
      </div>
    );
  }
  return null;
};

ImportErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string,
  })),
  clearUploadTaggedDataErrors: PropTypes.func,
};

const mapStateToProps = state => ({
  errors: taggedDataErrorsSelector(state),
});

export default connect(mapStateToProps, {
  clearUploadTaggedDataErrors,
})(ImportErrors);
